/* eslint-disable no-useless-escape */
import { EMAIL_GLOBAL_REGEX } from '../components/share/form/fields/email-capture';

const URL_GLOBAL_REGEX =
  /(((https?:\/\/)?|(www\.)|(http:\/\/))[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*))/gi;

export const getLinksAndMailsFromString = (value: string) => {
  const urlMatches = value.match(URL_GLOBAL_REGEX) || [];
  const emailMatches = value.match(EMAIL_GLOBAL_REGEX) || [];

  return [...urlMatches, ...emailMatches];
};
